(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["duo-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    var NOWRAP_MIN = 0.82;   /* overridden per block via data attribute */
    var WRAP_MIN = 0.55;
    var DESC_MIN = 0.6;
    var STEP = 0.02;

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    function overflowsX(els) {
      for (var i = 0; i < els.length; i++) {
        if (els[i].scrollWidth > els[i].clientWidth + 1) return true;
      }
      return false;
    }

    function overflowsY(boxes) {
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].scrollHeight > boxes[i].clientHeight + 1) return true;
      }
      return false;
    }

    /* Steps one shared scale down until nothing overflows. Shared, not
       per-slide -- that is what keeps sizes identical between slides. */
    function stepDown(root, varName, isOverflowing, min) {
      var scale = 1;
      root.style.setProperty(varName, '1');
      while (scale > min && isOverflowing()) {
        scale = Math.max(min, Math.round((scale - STEP) * 1000) / 1000);
        root.style.setProperty(varName, String(scale));
      }
      return scale;
    }

    function fitHeadings(root) {
      var headings = toArray(root.querySelectorAll('.duo-carousel-slide__heading'));
      var boxes = toArray(root.querySelectorAll('.duo-carousel-slide__heading-box'));
      if (!headings.length) return;

      var limit = parseFloat(root.dataset.headingShrinkLimit);
      var nowrapMin = isNaN(limit) ? NOWRAP_MIN : Math.min(1, Math.max(0.4, limit / 100));

      root.classList.remove('duo-carousel--heading-wrap');
      root.style.setProperty('--fit-heading', '1');

      var tooWide = function () { return overflowsX(headings); };
      if (!tooWide()) return;

      /* 1. Try to keep it on one line by shrinking, but only so far. */
      stepDown(root, '--fit-heading', tooWide, nowrapMin);
      if (!tooWide()) return;

      /* 2. Below that floor, wrap on word boundaries instead and size to
            the heading box's height. */
      root.classList.add('duo-carousel--heading-wrap');
      root.style.setProperty('--fit-heading', '1');

      var tooTall = function () { return overflowsY(boxes) || overflowsX(headings); };
      if (tooTall()) stepDown(root, '--fit-heading', tooTall, WRAP_MIN);
    }

    function fitDescriptions(root) {
      var boxes = toArray(root.querySelectorAll('.duo-carousel-slide__text'));
      if (!boxes.length) return;

      root.style.setProperty('--fit-desc', '1');
      var tooTall = function () { return overflowsY(boxes); };
      if (tooTall()) stepDown(root, '--fit-desc', tooTall, DESC_MIN);
    }

    function layout(root) {
      fitHeadings(root);
      fitDescriptions(root);
    }

    function init(root) {
      if (root.dataset.duoReady === '1') return;
      root.dataset.duoReady = '1';

      var slides = toArray(root.querySelectorAll('.duo-carousel-slide'));
      var arrows = root.querySelector('[data-duo-arrows]');
      if (!slides.length) return;

      if (slides.length < 2 && arrows) arrows.setAttribute('hidden', '');

      var bulletTrack = root.querySelector('[data-duo-bullets]');
      var bullets = [];

      var index = 0;
      function show(i) {
        if (i < 0 || i >= slides.length) i = (i % slides.length + slides.length) % slides.length;
        index = i;
        slides.forEach(function (slide, n) {
          var active = n === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        bullets.forEach(function (bullet, n) {
          var active = n === index;
          bullet.classList.toggle('is-active', active);
          bullet.setAttribute('aria-selected', active ? 'true' : 'false');
          bullet.tabIndex = active ? 0 : -1;
        });
      }
      root.__duoShow = show;

      /* Built from the real slide count -- the parent block can't know how
         many children content_for rendered. */
      if (bulletTrack) {
        if (slides.length < 2) {
          bulletTrack.setAttribute('hidden', '');
        } else {
          slides.forEach(function (slide, n) {
            var bullet = document.createElement('button');
            bullet.type = 'button';
            bullet.className = 'duo-carousel__bullet';
            bullet.setAttribute('role', 'tab');
            bullet.setAttribute('aria-label', 'Go to slide ' + (n + 1));
            bullet.addEventListener('click', function () { show(n); });
            bulletTrack.appendChild(bullet);
            bullets.push(bullet);
          });
        }
      }

      show(0);

      var prev = root.querySelector('.duo-carousel__arrow--prev');
      var next = root.querySelector('.duo-carousel__arrow--next');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { show(index - 1); }
        else if (event.key === 'ArrowRight') { show(index + 1); }
      });

      var frame = null;
      function schedule() {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          frame = null;
          layout(root);
        });
      }

      layout(root);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      window.addEventListener('load', schedule);

      toArray(root.querySelectorAll('img')).forEach(function (img) {
        if (!img.complete) img.addEventListener('load', schedule, { once: true });
      });

      var stage = root.querySelector('.duo-carousel__stage');
      if (window.ResizeObserver && stage) {
        new ResizeObserver(schedule).observe(stage);
      } else {
        window.addEventListener('resize', schedule);
      }
    }

    function boot(scope) {
      var container = scope || document;
      toArray(container.querySelectorAll('[data-duo-carousel]')).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });

    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var slide = target.closest('.duo-carousel-slide');
      if (!slide) return;
      var root = slide.closest('[data-duo-carousel]');
      if (!root || !root.__duoShow) return;
      var all = toArray(root.querySelectorAll('.duo-carousel-slide'));
      root.__duoShow(all.indexOf(slide));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-group"] && !Shopify.designMode) return;
  try {
    (function () {
    function getFullHeight(el) {
      const prevHeight = el.style.height;
      el.style.height = 'auto';
      const height = el.offsetHeight;
      el.style.height = prevHeight;
      return height;
    }

    class FaqAccordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.wrapper = el.querySelector('.faq-answer-wrapper');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }

      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';

        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.getBorderHeight()}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => { this.isClosing = false; };
      }

      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        requestAnimationFrame(() => this.expand());
      }

      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${getFullHeight(this.el)}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate(
          { height: [startHeight, endHeight] },
          { duration: 300, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => { this.isExpanding = false; };
      }

      getBorderHeight() {
        const style = getComputedStyle(this.el);
        return parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      }

      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = '';
        this.el.style.overflow = '';
      }
    }

    document.querySelectorAll('.faq-item').forEach(
      (el) => new FaqAccordion(el)
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function buildBullets(el, count) {
      var nav = el.querySelector('.image-carousel__nav-bullets');
      if (!nav || count < 2) return;

      for (var i = 0; i < count; i++) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'image-carousel__nav-bullet';
        bullet.setAttribute('data-glide-dir', '=' + i);
        bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));

        var inactive = document.createElement('span');
        inactive.className = 'bullet-inactive';
        inactive.setAttribute('aria-hidden', 'true');

        var active = document.createElement('span');
        active.className = 'bullet-active';
        active.setAttribute('aria-hidden', 'true');

        bullet.appendChild(inactive);
        bullet.appendChild(active);
        nav.appendChild(bullet);
      }
    }

    function initImageCarousel(el) {
      if (!el) return;

      if (typeof Glide === 'undefined') {
        setTimeout(function () { initImageCarousel(el); }, 150);
        return;
      }

      var slidesUl = el.querySelector('.glide__slides');
      var originalSlides = Array.prototype.slice.call(el.querySelectorAll('.image-carousel-slide'));
      var originalCount = originalSlides.length;
      if (originalCount === 0) return;

      buildBullets(el, originalCount);

      if (originalCount < 2) {
        var controls = el.querySelector('.image-carousel__controls');
        if (controls) controls.style.display = 'none';
      }

      var MIN_TOTAL_SLIDES = 12;
      if (originalCount < MIN_TOTAL_SLIDES && slidesUl) {
        var repeats = Math.ceil(MIN_TOTAL_SLIDES / originalCount);
        for (var r = 1; r < repeats; r++) {
          originalSlides.forEach(function (slide) {
            slidesUl.appendChild(slide.cloneNode(true));
          });
        }
      }


      var totalCount = el.querySelectorAll('.image-carousel-slide').length;

      function safePerView(desired, count) {
        if (count <= 1) return 1;
        return Math.min(desired, Math.max(1.2, count - 0.3));
      }

      function currentSettings(count) {
        var w = window.innerWidth;
        var maxSize = parseFloat(getComputedStyle(el).getPropertyValue('--image-carousel-max-size')) || 500;
        var desired;

        if (w <= 479) desired = 1.3;
        else if (w <= 767) desired = 2.3;
        else if (w <= 1023) desired = 3.3;
        else desired = 4.3;

        var cappedPerView = (w / maxSize) + 0.3;
        if (cappedPerView > desired) desired = cappedPerView;

        return { perView: safePerView(desired, count), focusAt: 'center' };
      }

      var initialSettings = currentSettings(totalCount);

      var instance = new Glide('#' + el.id, {
        type: 'carousel',
        perView: initialSettings.perView,
        focusAt: initialSettings.focusAt,
        gap: parseFloat(getComputedStyle(el).getPropertyValue('--image-carousel-gap')) || 12,
        arrows: true,
        swipeThreshold: 80,
        dragThreshold: 120,
      });

      function realIndex() {
        return ((instance.index % originalCount) + originalCount) % originalCount;
      }

      function updateActiveBullet() {
        var bullets = el.querySelectorAll('.image-carousel__nav-bullet');
        var realIndex = instance.index % originalCount;
        bullets.forEach(function (bullet, i) {
          bullet.classList.toggle('image-carousel__nav-bullet--active', i === realIndex);
        });
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            instance.mount();
            updateActiveBullet();
            instance.on('run.after', updateActiveBullet);

            el.querySelectorAll('.image-carousel__nav-bullet').forEach(function (bullet) {
              bullet.addEventListener('click', function () {
                var dir = bullet.getAttribute('data-glide-dir');
                if (dir) instance.go(dir);
              });
            });

            var prevBtn = el.querySelector('.image-carousel__nav-arrow--prev');
            var nextBtn = el.querySelector('.image-carousel__nav-arrow--next');
            if (prevBtn) prevBtn.addEventListener('click', function () { instance.go('<'); });
            if (nextBtn) nextBtn.addEventListener('click', function () { instance.go('>'); });
          }
        });
      }, { threshold: 0.1 });

      observer.observe(el);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          instance.update(currentSettings(totalCount));
        }, 200);
      });
    }

    document.querySelectorAll('.image-carousel').forEach(initImageCarousel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tier-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var MIN_FONT_PX = 6;
    var FIT_ITERATIONS = 8;
    var GLIDE_RETRY_MS = 150;
    var GLIDE_MAX_RETRIES = 40;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* ---------------- text fitting ---------------- */

    function fitText(container, els, minPx) {
      if (!container || !els.length) return true;

      els.forEach(function (el) { el.style.fontSize = ''; });

      if (container.clientHeight <= 0) return true;

      function fits() {
        return container.scrollHeight <= container.clientHeight + 1;
      }

      if (fits()) return true;

      var natural = els.map(function (el) {
        return parseFloat(getComputedStyle(el).fontSize) || minPx;
      });

      function apply(k) {
        els.forEach(function (el, i) {
          el.style.fontSize = Math.max(minPx, natural[i] * k) + 'px';
        });
      }

      var lo = natural.reduce(function (acc, n) {
        return Math.min(acc, minPx / n);
      }, 1);
      var hi = 1;

      apply(lo);
      if (!fits()) return false;

      for (var i = 0; i < FIT_ITERATIONS; i++) {
        var mid = (lo + hi) / 2;
        apply(mid);
        if (fits()) { lo = mid; } else { hi = mid; }
      }
      apply(lo);
      return true;
    }

    /* The floor the shrinking stops at, per card. The base size itself is
       CSS-driven, so nothing else here needs to know about the settings:
       clearing the inline font-size hands the element straight back to the
       merchant's configured size. */
    function minFontFor(col) {
      var card = col.closest('.tier-card');
      if (!card) return MIN_FONT_PX;
      var configured = parseFloat(card.getAttribute('data-min-font-size'));
      return configured > 0 ? configured : MIN_FONT_PX;
    }

    function fitCard(col) {
      if (!col || !col.isConnected) return;

      var container = col.querySelector('.tier-card__info-top');
      var atcRow = col.querySelector('.tier-card__atc-row');
      var title = col.querySelector('.tier-card__title');
      var desc = col.querySelector('.tier-card__description');
      if (!container || !title) return;

      var minPx = minFontFor(col);

      /* Only meaningful while info-top is absolutely positioned (mobile);
         cleared otherwise so a stale value can't linger across breakpoints. */
      container.style.bottom = '';
      if (atcRow && getComputedStyle(container).position === 'absolute') {
        container.style.bottom = atcRow.getBoundingClientRect().height + 'px';
      }

      title.style.fontSize = '';
      if (desc) desc.style.fontSize = '';

      if (desc) {
        if (fitText(container, [desc], minPx)) return;
      }
      fitText(container, desc ? [title, desc] : [title], minPx);
    }

    var pendingCols = [];
    var rafId = null;
    var suppress = false;

    function scheduleFit(col) {
      if (pendingCols.indexOf(col) === -1) pendingCols.push(col);
      if (rafId !== null) return;

      rafId = requestAnimationFrame(function () {
        rafId = null;
        suppress = true;
        var batch = pendingCols;
        pendingCols = [];
        batch.forEach(fitCard);
        requestAnimationFrame(function () { suppress = false; });
      });
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      if (suppress) return;
      entries.forEach(function (entry) {
        var col = entry.target.classList.contains('tier-card__info-col')
          ? entry.target
          : entry.target.closest('.tier-card__info-col');
        if (col) scheduleFit(col);
      });
    });

    function observeCard(col) {
      if (col.__tierCardObserved) return;
      col.__tierCardObserved = true;
      resizeObserver.observe(col);
      var atcRow = col.querySelector('.tier-card__atc-row');
      if (atcRow) resizeObserver.observe(atcRow);
      scheduleFit(col);
    }

    function unobserveCard(col) {
      if (!col.__tierCardObserved) return;
      col.__tierCardObserved = false;
      resizeObserver.unobserve(col);
      var atcRow = col.querySelector('.tier-card__atc-row');
      if (atcRow) resizeObserver.unobserve(atcRow);
    }

    /* ---------------- Glide ---------------- */

    /* The library is loaded once by the section with `defer`. Rather than
       blind-polling, wait on the script tag's own load event and keep the
       retry loop only as a fallback for cache/ordering edge cases. */
    var glideQueue = [];
    var glideListenerBound = false;

    function flushGlideQueue() {
      var queued = glideQueue;
      glideQueue = [];
      queued.forEach(function (el) { mountGlide(el); });
    }

    function bindGlideScript() {
      if (glideListenerBound) return;
      var script = document.querySelector('script[src*="glide"]');
      if (!script) return;
      glideListenerBound = true;
      script.addEventListener('load', flushGlideQueue, { once: true });
    }

    function updateBulletState(el, index) {
      var bullets = el.querySelectorAll('.tier-card__nav-bullet');
      Array.prototype.forEach.call(bullets, function (bullet, n) {
        bullet.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    function mountGlide(el) {
      if (!el || el.__tierGlide || !el.isConnected) return;
      if (typeof Glide === 'undefined') return;

      var instance = new Glide('#' + el.id, {
        type: 'slider',
        perView: 1,
        bound: true,
        arrows: true,
        swipeThreshold: 80,
        dragThreshold: 120,
        animationDuration: prefersReducedMotion() ? 0 : 400,
        classes: {
          nav: {
            active: 'tier-card__nav-bullet--active'
          }
        }
      });

      el.__tierGlide = instance;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          el.__tierGlideIO = null;

          instance.on(['mount.after', 'run.after'], function () {
            updateBulletState(el, instance.index);
          });

          instance.mount();

          Array.prototype.forEach.call(
            el.querySelectorAll('.tier-card__nav-bullet'),
            function (bullet) {
              bullet.addEventListener('click', function () {
                var dir = bullet.getAttribute('data-glide-dir');
                if (dir) instance.go(dir);
              });
            }
          );
        });
      }, { threshold: 0.1 });

      el.__tierGlideIO = observer;
      observer.observe(el);
    }

    function initTierCardCarousel(el, attempt) {
      if (!el || el.__tierGlide) return;

      var imageCount = parseInt(el.getAttribute('data-image-count'), 10) || 0;
      if (imageCount <= 1) return;

      if (typeof Glide === 'undefined') {
        if (glideQueue.indexOf(el) === -1) glideQueue.push(el);
        bindGlideScript();

        var next = (attempt || 0) + 1;
        if (next > GLIDE_MAX_RETRIES) return;
        el.__tierGlideTimer = setTimeout(function () {
          el.__tierGlideTimer = null;
          initTierCardCarousel(el, next);
        }, GLIDE_RETRY_MS);
        return;
      }

      mountGlide(el);
    }

    function destroyTierCardCarousel(el) {
      /* Previously the retry timer kept firing after a section unload. */
      if (el.__tierGlideTimer) {
        clearTimeout(el.__tierGlideTimer);
        el.__tierGlideTimer = null;
      }
      var queued = glideQueue.indexOf(el);
      if (queued !== -1) glideQueue.splice(queued, 1);

      if (el.__tierGlideIO) {
        el.__tierGlideIO.disconnect();
        el.__tierGlideIO = null;
      }
      if (el.__tierGlide) {
        try { el.__tierGlide.destroy(); } catch (e) {}
        el.__tierGlide = null;
      }
    }

    /* ---------------- add to cart ---------------- */

    function initAtcForm(form) {
      if (form.__tierCardBound) return;
      form.__tierCardBound = true;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        var formData = new FormData(form);

        if (button) button.disabled = true;

        fetch(form.getAttribute('action') || '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            window.location.href = '/cart';
          })
          .catch(function () {
            setTimeout(function () {
              if (button) button.disabled = false;
            }, 1500);
          });
      });
    }

    /* ---------------- lifecycle ---------------- */

    function initAll(root) {
      var scope = root || document;
      scope.querySelectorAll('.tier-card__info-col').forEach(observeCard);
      scope.querySelectorAll('.tier-card-glide').forEach(function (el) {
        initTierCardCarousel(el, 0);
      });
      scope.querySelectorAll('.tier-card__atc-form').forEach(initAtcForm);
    }

    function teardown(root) {
      var scope = root || document;
      scope.querySelectorAll('.tier-card__info-col').forEach(unobserveCard);
      scope.querySelectorAll('.tier-card-glide').forEach(destroyTierCardCarousel);
    }

    function refitAll(root) {
      (root || document).querySelectorAll('.tier-card__info-col').forEach(scheduleFit);
    }

    function boot() {
      initAll(document);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { refitAll(document); });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });

    /* Editing a card's settings can change how much text there is, or how
       big it starts out. */
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.querySelectorAll) refitAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
